import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { CityService } from 'src/app/shared/API-Service/services/city.service';
import { DonationCallRequestService } from 'src/app/shared/API-Service/services/donation-call-request.service';



@Component({
  selector: 'app-insert-donation-call-request',
  templateUrl: './insert-donation-call-request.component.html',
  styleUrls: ['./insert-donation-call-request.component.css']
})
export class InsertDonationCallRequestComponent implements OnInit {
  recordtoupdate: any;
  cities:any;
  donationcallrequestForm : FormGroup;
  update:boolean = false;
  button:boolean = false;
  constructor(private _DonationCallRequestService:DonationCallRequestService,private _Router:Router,private _FormBuilder:FormBuilder, private _CityService:CityService) { }

  ngOnInit(): void {
    this.initiate();
    this.getcities();
    this.checkEdit();
  }

getcities(){
  this._CityService.GetCity().subscribe((res) => {
    this.cities = res.data;
  },(err) => {
    console.log('their is a problem ');
  },() => {
    console.log("completed");
  });
}
get fc() {
  return this.donationcallrequestForm.controls;
}
checkEdit() {
  this._DonationCallRequestService.Data.subscribe((res) => {
    if (res != null) {
      this.donationcallrequestForm = this._FormBuilder.group({
        name: [res.name, Validators.required],
        mobile: [res.mobile, [Validators.required, Validators.pattern(`^01[0125]{1}[0-9]{8}`)]],
        cityId: [res.cityId, Validators.required],
      });
      this.update = true;
      this.recordtoupdate = res ;
    
    } else {
      console.log(`not found on data`);
      // this.initiate();
    }
   
  });
}

  initiate(){
    this.donationcallrequestForm = this._FormBuilder.group({
      name: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.pattern(`^01[0125]{1}[0-9]{8}`)]],
      cityId: ['', Validators.required]
    });
  }

  onSubmit(){
    this.button = true;
   if(this.update == false && this.donationcallrequestForm.status == "VALID"){
  
    this._DonationCallRequestService.CreateDonationCallRequest(this.donationcallrequestForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.donationcallrequestForm.reset();
      this._Router.navigate(['/content/admin/ViewDonationCallRequest']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
   } else if(this.donationcallrequestForm.status == "VALID"){
    this.donationcallrequestForm.addControl('id', new FormControl(this.recordtoupdate.id, Validators.required));
    this._DonationCallRequestService.UpdateDonationCallRequest(this.donationcallrequestForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.donationcallrequestForm.reset();
      this._Router.navigate(['/content/admin/ViewDonationCallRequest']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
    }, () => {
      console.log('completed ');
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ حميع الحقول"   
    })
    this.donationcallrequestForm.markAllAsTouched();
    this.button = false;
   }
  }

 
  ngOnDestroy(){
    this._DonationCallRequestService.Data.next(null);
     }

}
